/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from "react";
import { MarkdownContent, Loading } from "@/shared/ui";
import { useTranslation } from "react-i18next";
import PolicyPageLayout from "../service-terms/PolicyPageLayout";
import { useDocumentContent } from "../shared/hooks/useDocumentContent";
import { PageSEO, HreflangTags, BreadcrumbSchema } from "@/shared/seo";

const AcceptableUsePolicy: React.FC = () => {
  const { t } = useTranslation("@pages/policy");
  const { content, isLoading } = useDocumentContent(
    'acceptable-use-policy',
    `# ${t("acceptableUsePolicy.title")}\n\nContent coming soon.`
  );

  if (isLoading) return <Loading mode="section" size="lg" />;

  return (
    <>
      <PageSEO
        title={t("acceptableUsePolicy.title")}
        description={t("acceptableUsePolicy.description", "Acceptable Use Policy for Housien - Rules for using our platform.")}
        noIndex={false}
      />
      <HreflangTags />
      <BreadcrumbSchema
        items={[
          { name: t("breadcrumb.home"), url: "/" },
          { name: t("acceptableUsePolicy.title"), url: "/acceptable-use/v1" },
        ]}
      />

      <PolicyPageLayout
        title={t("acceptableUsePolicy.title")}
        lastUpdated="July 2026"
        version="1"
        lastUpdatedLabel={t("acceptableUsePolicy.lastUpdated", "Last updated")}
        versionLabel={t("acceptableUsePolicy.version", "Version")}
      >
        <MarkdownContent content={content} headingOffset={1} />
      </PolicyPageLayout>
    </>
  );
};

export default AcceptableUsePolicy;
